import { isCurrentPathPresent } from "utils/common";
import Image from "./Image";

const DecorativeImage = ({
	isDecorativeImage = false,
	decorativeImage = [],
	baseClass,
	fairy: { location, image },
}) => {
	const imageToShow = decorativeImage?.find((descorative) =>
		isCurrentPathPresent(descorative.showOn)
	);
	return (
		<>
			{isDecorativeImage ? (
				<Image
					image={{
						alt: imageToShow?.altText,
						baseClass,
						url: imageToShow?.decorative.url,
					}}
				/>
			) : (
				<Image
					image={{
						baseClass,
						url: `${location}/${image}`,
						loading: "lazy",
					}}
				/>
			)}
		</>
	);
};

export default DecorativeImage;
